(function () {
  if (window.__bundleBuilderInit) return;
  window.__bundleBuilderInit = true;

  function money(cents) {
    var n = Math.round(cents / 100);
    try { return new Intl.NumberFormat('vi-VN').format(n) + '₫'; }
    catch (e) { return n.toLocaleString() + '₫'; }
  }

  function openModal(el) {
    if (!el) return;
    el.classList.add('is-open');
    document.documentElement.classList.add('bb-lock');
  }
  function closeModal(el) {
    if (!el) return;
    el.classList.remove('is-open');
    if (!document.querySelector('.bbmodal.is-open, .builder-picker.is-open')) {
      document.documentElement.classList.remove('bb-lock');
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-bb-open]');
    if (opener) { openModal(document.getElementById(opener.getAttribute('data-bb-open'))); return; }

    if (e.target.closest('[data-bb-close]')) {
      closeModal(e.target.closest('.bbmodal, .builder-picker'));
      return;
    }
    var pickerOpen = e.target.closest('[data-picker-open]');
    if (pickerOpen) { openModal(document.getElementById(pickerOpen.getAttribute('data-picker-open'))); return; }

    var pick = e.target.closest('[data-pick]');
    if (pick) { selectOption(pick.closest('[data-option]')); return; }

    var sub = e.target.closest('[data-submit]');
    if (sub) { submitBuilder(sub.closest('[data-builder]')); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var picker = document.querySelector('.builder-picker.is-open');
    if (picker) { closeModal(picker); return; }
    var modal = document.querySelector('.bbmodal.is-open');
    if (modal) closeModal(modal);
  });

  function selectOption(opt) {
    if (!opt || opt.getAttribute('data-available') === 'false') return;
    var builder = opt.closest('[data-builder]');
    if (!builder) return;
    var step = builder.querySelector('[data-step-id="' + opt.getAttribute('data-target') + '"]');
    if (!step) return;
    step.dataset.variantId = opt.getAttribute('data-variant-id');
    step.dataset.cents = opt.getAttribute('data-cents');
    var thumb = step.querySelector('[data-thumb]');
    var img = opt.getAttribute('data-img');
    if (thumb && img) thumb.innerHTML = '<img src="' + img + '" alt="" width="64" height="64">';
    step.querySelector('[data-name]').textContent = opt.getAttribute('data-title');
    step.querySelector('[data-price]').textContent = opt.getAttribute('data-price');
    step.classList.add('is-selected');
    closeModal(opt.closest('.builder-picker'));
    refresh(builder);
  }

  function refresh(builder) {
    if (!builder) return;
    var steps = builder.querySelectorAll('[data-step]');
    var total = 0, ready = true;
    steps.forEach(function (s) {
      if (s.dataset.cents) total += parseInt(s.dataset.cents, 10);
      if (s.getAttribute('data-required') === 'true' && !s.dataset.variantId) ready = false;
    });
    var suffix = builder.getAttribute('data-suffix') || '';
    var t = builder.querySelector('[data-total]');
    if (t) t.textContent = total > 0 ? (money(total) + suffix) : '—';
    var sub = builder.querySelector('[data-submit]');
    if (sub) sub.disabled = !ready;
  }

  function showError(b, msg) {
    var e = b.querySelector('[data-error]');
    if (e) { e.textContent = msg; e.hidden = false; }
  }

  function submitBuilder(builder) {
    if (!builder) return;
    var steps = builder.querySelectorAll('[data-step]');
    var props = {};
    var name = builder.getAttribute('data-bundle-name');
    if (name) props['Bundle'] = name;
    var months = parseInt(builder.getAttribute('data-rental-months'), 10) || 1;
    var dateEl = builder.querySelector('[data-date]');
    if (dateEl && dateEl.value) {
      props['Rental start'] = dateEl.value;
      if (dateEl.dataset.end) props['Return date'] = dateEl.dataset.end;
      props['Rental period'] = months + ' month(s)';
    }

    var items = [], missing = false;
    steps.forEach(function (s) {
      if (s.dataset.variantId) {
        items.push({ id: parseInt(s.dataset.variantId, 10), quantity: 1, properties: props });
      } else if (s.getAttribute('data-required') === 'true') {
        missing = true;
      }
    });
    if (missing || items.length === 0) { showError(builder, 'Please choose all items.'); return; }

    var sub = builder.querySelector('[data-submit]');
    if (sub) { sub.disabled = true; sub.classList.add('loading'); }
    var errEl = builder.querySelector('[data-error]');
    if (errEl) errEl.hidden = true;

    fetch((window.routes ? window.routes.cart_add_url : '/cart/add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { showError(builder, res.description || res.message || 'Error'); return; }
        window.location = window.routes ? window.routes.cart_url : '/cart';
      })
      .catch(function () { showError(builder, 'Something went wrong, please try again.'); })
      .finally(function () { if (sub) { sub.disabled = false; sub.classList.remove('loading'); } });
  }

  function fmtDate(d) {
    try { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); }
    catch (e) { return d.toISOString().split('T')[0]; }
  }
  function addMonths(date, months) {
    var d = date.getDate();
    var end = new Date(date.getFullYear(), date.getMonth() + months, d);
    // clamp when the target month has fewer days (e.g. 31 Jan + 1mo -> 28/29 Feb)
    if (end.getDate() !== d) end.setDate(0);
    return end;
  }
  function updatePeriod(input) {
    var wrap = input.closest('.builder-date');
    var out = wrap ? wrap.querySelector('[data-period]') : null;
    if (!out) return;
    if (!input.value) { out.textContent = ''; input.dataset.end = ''; return; }
    var builder = input.closest('[data-builder]');
    var months = (builder && parseInt(builder.getAttribute('data-rental-months'), 10)) || 1;
    var start = new Date(input.value + 'T00:00:00');
    var end = addMonths(start, months);
    input.dataset.end = end.toISOString().split('T')[0];
    out.textContent = '→ Return by ' + fmtDate(end) + ' · ' + months + '-month rental';
  }
  document.addEventListener('change', function (e) {
    var d = e.target.closest && e.target.closest('[data-date]');
    if (d) updatePeriod(d);
  });

  function initDates() {
    document.querySelectorAll('[data-date]').forEach(function (d) {
      if (!d.min) d.min = new Date().toISOString().split('T')[0];
      if (d.value) updatePeriod(d);
    });
  }
  if (document.readyState !== 'loading') initDates();
  else document.addEventListener('DOMContentLoaded', initDates);
})();
